import React from 'react';
import { FEATURES, STATS } from '../constants';
import RevealOnScroll from './RevealOnScroll';

const Features: React.FC = () => {
  return (
    <section id="features" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
          <RevealOnScroll>
            <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-4">
              OTL Members Around the Maldives Enjoy <span className="text-brand-600">Easy & Affordable</span> Global Shipping
            </h2>
          </RevealOnScroll>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-20 border-b border-slate-100 pb-8 md:pb-12">
          {STATS.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <RevealOnScroll key={index} delay={index * 100} className="text-center">
                <div className="flex flex-col items-center">
                  <div className="text-brand-600 mb-2 md:mb-3">
                    <Icon className="w-6 h-6 md:w-8 md:h-8" />
                  </div>
                  <div className="text-2xl md:text-4xl font-bold text-slate-900 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm font-medium text-slate-500 uppercase tracking-wide">{stat.label}</div>
                </div>
              </RevealOnScroll>
            )
          })}
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {FEATURES.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <RevealOnScroll key={feature.id} delay={index * 100} className="h-full">
                <div className="p-6 rounded-2xl bg-white hover:bg-slate-50 transition-colors h-full flex flex-col items-center text-center border border-transparent hover:border-slate-100 shadow-sm md:shadow-none hover:shadow-lg">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-brand-50 rounded-full flex items-center justify-center mb-4 md:mb-6">
                    <Icon className="w-7 h-7 md:w-8 md:h-8 text-brand-600" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2 md:mb-3">{feature.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              </RevealOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;